import { render, staticRenderFns } from "./projectSelect.vue?vue&type=template&id=3b2d1540&scoped=true"
import script from "./projectSelect.vue?vue&type=script&lang=js"
export * from "./projectSelect.vue?vue&type=script&lang=js"
import style0 from "./projectSelect.vue?vue&type=style&index=0&id=3b2d1540&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2d1540",
  null
  
)

export default component.exports